<template>
  <g>
    <path
      d="M5 19.0716C5 20.1367 5.8483 21.0002 6.89474 21.0002H17.3158C18.3622 21.0002 19.2105 20.1367 19.2105 19.0716V4.92875C19.2105 3.86363 18.3622 3.00018 17.3158 3.00018H10.1505C9.7872 3.00018 9.44148 3.1594 9.20166 3.43718L5.31432 7.9397C5.11173 8.17434 5 8.47604 5 8.78841V19.0716Z"
      fill="white"
    />
    <path
      d="M5 19.0716C5 20.1367 5.8483 21.0002 6.89474 21.0002H17.3158C18.3622 21.0002 19.2105 20.1367 19.2105 19.0716V4.92875C19.2105 3.86363 18.3622 3.00018 17.3158 3.00018H10.1505C9.7872 3.00018 9.44148 3.1594 9.20166 3.43718L5.31432 7.9397C5.11173 8.17434 5 8.47604 5 8.78841V19.0716Z"
      fill="url(#paint0_linear_939_1092)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.5 19.0716C4.5 20.4045 5.56385 21.5002 6.89474 21.5002H17.3158C18.6467 21.5002 19.7105 20.4045 19.7105 19.0716V4.92875C19.7105 3.59587 18.6467 2.50018 17.3158 2.50018H10.1505C9.64017 2.50018 9.15689 2.72392 8.8232 3.11043L4.93586 7.61294C4.65421 7.93916 4.5 8.35708 4.5 8.78841V19.0716ZM6.89474 20.5002C6.13275 20.5002 5.5 19.869 5.5 19.0716V8.78841C5.5 8.595 5.56925 8.40952 5.69278 8.26645L9.58012 3.76393C9.72607 3.59488 9.93422 3.50018 10.1505 3.50018H17.3158C18.0778 3.50018 18.7105 4.1314 18.7105 4.92875V19.0716C18.7105 19.869 18.0778 20.5002 17.3158 20.5002H6.89474Z"
      fill="#3E7DC0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.47369 7.80371H5V8.80371H8.47369C9.45576 8.80371 10.2368 7.99584 10.2368 7.018V3.00014H9.23684V7.018C9.23684 7.46031 8.88686 7.80371 8.47369 7.80371Z"
      fill="#3E7DC0"
    />
    <g filter="url(#filter0_d_939_1092)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 7.50018C12 7.22404 12.2239 7.00018 12.5 7.00018H14.5C14.7761 7.00018 15 7.22404 15 7.50018C15 7.77633 14.7761 8.00018 14.5 8.00018H12.5C12.2239 8.00018 12 7.77633 12 7.50018Z"
        fill="#3E7DC0"
      />
    </g>
    <g filter="url(#filter1_d_939_1092)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 10.5002C12 10.224 12.2239 10.0002 12.5 10.0002H16.5C16.7761 10.0002 17 10.224 17 10.5002C17 10.7763 16.7761 11.0002 16.5 11.0002H12.5C12.2239 11.0002 12 10.7763 12 10.5002Z"
        fill="#3E7DC0"
      />
    </g>
    <rect x="1.5" y="14.0002" width="21" height="10" rx="2" fill="#3E7DC0" />
    <path
      d="M6.85938 16.2892C7.58333 16.2892 8.125 16.4468 8.48438 16.7619C8.84635 17.077 9.02734 17.5249 9.02734 18.1057C9.02734 18.3661 8.98958 18.6161 8.91406 18.8557C8.84115 19.0952 8.72005 19.3088 8.55078 19.4963C8.38411 19.6838 8.16146 19.8322 7.88281 19.9416C7.60677 20.051 7.26562 20.1057 6.85938 20.1057H6.42578V22.0002H4.88281V16.2892H6.85938ZM6.82422 17.5353H6.42578V18.8478H6.73047C6.86328 18.8478 6.98698 18.8257 7.10156 18.7814C7.21615 18.7346 7.30729 18.6603 7.375 18.5588C7.44531 18.4546 7.48047 18.3166 7.48047 18.1447C7.48047 17.965 7.42708 17.8192 7.32031 17.7072C7.21354 17.5926 7.04818 17.5353 6.82422 17.5353Z"
      fill="#F8F8F8"
    />
    <path
      d="M11.9141 16.2892C12.638 16.2892 13.1797 16.4468 13.5391 16.7619C13.901 17.077 14.082 17.5249 14.082 18.1057C14.082 18.3661 14.0443 18.6161 13.9688 18.8557C13.8958 19.0952 13.7747 19.3088 13.6055 19.4963C13.4388 19.6838 13.2161 19.8322 12.9375 19.9416C12.6615 20.051 12.3203 20.1057 11.9141 20.1057H11.4805V22.0002H9.9375V16.2892H11.9141ZM11.8789 17.5353H11.4805V18.8478H11.7852C11.918 18.8478 12.0417 18.8257 12.1562 18.7814C12.2708 18.7346 12.362 18.6603 12.4297 18.5588C12.5 18.4546 12.5352 18.3166 12.5352 18.1447C12.5352 17.965 12.4818 17.8192 12.375 17.7072C12.2682 17.5926 12.1029 17.5353 11.8789 17.5353Z"
      fill="#F8F8F8"
    />
    <path
      d="M16.4297 15.9221V16.7853C16.4297 17.1135 16.4219 17.3895 16.4062 17.6135C16.3932 17.8348 16.3802 18.0041 16.3672 18.1213H16.4375C16.5339 17.9676 16.6432 17.8452 16.7656 17.7541C16.888 17.6629 17.0234 17.5978 17.1719 17.5588C17.3203 17.5171 17.4818 17.4963 17.6562 17.4963C17.9479 17.4963 18.2109 17.5523 18.4453 17.6642C18.6823 17.7762 18.8711 17.952 19.0117 18.1916C19.1523 18.4286 19.2227 18.7385 19.2227 19.1213V22.0002H17.6875V19.5861C17.6875 19.2918 17.6445 19.0705 17.5586 18.9221C17.4727 18.771 17.3398 18.6955 17.1602 18.6955C16.9753 18.6955 16.8294 18.7489 16.7227 18.8557C16.6159 18.9598 16.5404 19.1135 16.4961 19.3166C16.4518 19.5171 16.4297 19.7632 16.4297 20.0549V22.0002H14.9023V15.9221H16.4297Z"
      fill="#F8F8F8"
    />
    <defs>
      <filter
        id="filter0_d_939_1092"
        x="8"
        y="7.00018"
        width="11"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1092"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1092"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_939_1092"
        x="8"
        y="10.0002"
        width="13"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1092"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1092"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_939_1092"
        x1="15"
        y1="3.00018"
        x2="15"
        y2="19.5002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </g>
</template>
